import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IIngressEventMappingModel } from '../../../models';
import { DeleteIngressEventMappingPayload, IngressEventMappingPayload, IngressEventMappingState, UpdateIngressEventMappingPayload } from '../../actions/types/services/IngressEventsMappingTypes';

/**
 * Initial Ingress Events in the store
 */
const initialState: IngressEventMappingState = {
  ingressEventMappingList: [],
};

const getUpdateIndex = (ingressEventMappingList: IIngressEventMappingModel[], serviceOperationName: string, ingressEventName: string, ingressEventVersion: string) => {
  const index = ingressEventMappingList.findIndex((item) => item.serviceOperationName === serviceOperationName && item.eventName === ingressEventName && item.eventVersion === ingressEventVersion);
  if (index < 0) return 0;
  return index;
};

const ingressEventMappingSlice = createSlice({
  name: 'ingressEventMapping',
  initialState,
  reducers: {
    addIngressEventMapping: (
      state,
      actions: PayloadAction<IngressEventMappingPayload>
    ) => {
      state.ingressEventMappingList.push(actions.payload.ingressEventMapping);
    },
    addAllIngressEventMapping: (
      state,
      actions: PayloadAction<IngressEventMappingState>
    ) => {
      state.ingressEventMappingList = [...actions.payload.ingressEventMappingList];
    },
    addIngressEventMappingList: (
      state,
      actions: PayloadAction<IngressEventMappingState>
    ) => {
      state.ingressEventMappingList = [...state.ingressEventMappingList, ...actions.payload.ingressEventMappingList];
    },
    deleteIngressEventMapping: (state, actions: PayloadAction<DeleteIngressEventMappingPayload>) => {
      state.ingressEventMappingList.splice(getUpdateIndex(state.ingressEventMappingList, actions.payload.serviceOperationName, actions.payload.ingressEventName ?? '', actions.payload.ingressEventVersion ?? ''), 1);
    },

    updateIngressEventMapping: (state, actions: PayloadAction<UpdateIngressEventMappingPayload>) => {
      state.ingressEventMappingList.splice(getUpdateIndex(state.ingressEventMappingList, actions.payload.serviceOperationName, actions.payload.ingressEventName ?? '', actions.payload.ingressEventVersion), 1, actions.payload.ingressEventMapping);
    },

    clearIngressEventMapping: (state) => {
      state.ingressEventMappingList = initialState.ingressEventMappingList;
    },
  }
});
export const {
  addIngressEventMapping,
  addAllIngressEventMapping,
  addIngressEventMappingList,
  deleteIngressEventMapping,
  updateIngressEventMapping,
  clearIngressEventMapping,

} = ingressEventMappingSlice.actions;
export default ingressEventMappingSlice.reducer;
